module.exports = __webpack_public_path__ + "static/BM-silver-brook-1024x1024-4627342e9c91eb73866a99695ef8e1df.png";